import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';

import { InputComponent } from '../form/InputComponent';
import { Button } from '../Button';

import { removeUserFromAccount, selectUser, updateAllUsers } from '../../reducers/account.reducer';
import { Modal } from '../modal/Modal';
import { useEffect, useState } from 'react';
import {
  ActionsContainer,
  AdminUserListContainer,
  ButtonsContainer,
  ConfirmContainer,
  MessageContainer,
  UserListBody,
  UserListContainer,
  UserListDataContent,
} from './Administration.styles';
import { RiAddLine } from 'react-icons/ri';
import { FaRegSave } from 'react-icons/fa';
import { setModal } from 'src/reducers/app.reducer';
import { ACCOUNT_ROLES, MODAL_TYPES } from 'src/utils/constants';

interface AdministrationProps {
  account: any;
  setAccount: any;
  admin: boolean;
}
export const Administration: React.FC<AdministrationProps> = ({ account, setAccount, admin }) => {
  const dispatch = useDispatch<any>();
  const user = useSelector(selectUser);
  const [showModal, setShowModal] = useState(false);
  const [displayConfirmModal, setDisplayConfirmModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    const accountCopy = _.cloneDeep(account);
    setUserList([...accountCopy.users]);
  }, [account]);

  const handleUserInfosChange = (name, user, value = undefined, isCheckBox: boolean = false) => {
    if (name.target) {
      value = name.target.value;
      name = name.target.name;
    }

    setUserList(prevUserList => {
      const updatedUserList = prevUserList.map(userAccount => {
        if (userAccount._id === user._id) {
          return {
            ...userAccount,
            [name]: isCheckBox ? name.target.checked : value,
          };
        }
        return userAccount;
      });
      return updatedUserList;
    });
  };

  const handleAccountOfficerChange = async (e, user) => {
    const accountCopy = _.cloneDeep(account);
    accountCopy.users.forEach(userItem => (userItem.role = userItem._id === user._id ? 'accountOfficer' : 'admin'));
    await dispatch(setAccount(accountCopy));
  };

  const handlePopUp = async user => {
    if (user.role === 'accountOfficer') {
      setShowModal(true);
      return;
    }
    setSelectedUser(user);
    setDisplayConfirmModal(true);
  };

  const handleCloseConfirmModal = () => {
    setSelectedUser(null);
    setDisplayConfirmModal(false);
  };

  const deleteUser = user => {
    dispatch(removeUserFromAccount({ userId: user._id }));
    handleCloseConfirmModal();
    toast.info(`L'utilisateur ${user?.name} a été supprimer !`);
  };

  const handleAddUser = async () => {
    await dispatch(setModal({ show: true, type: MODAL_TYPES.ADD_USER }));
  };

  const handleUpdateAllUsers = async () => {
    dispatch(updateAllUsers({ accountId: account._id, users: userList }));
    toast.info(`les infos des utilisateurs ont bien été mis à jour !`);
  };

  const accountRoleOptions = [
    { label: 'Referent RGPD', value: ACCOUNT_ROLES.AccountOfficer },
    { label: 'Administrateur', value: ACCOUNT_ROLES.ADMIN },
    { label: 'Collaborateur', value: ACCOUNT_ROLES.Guest },
  ];

  const getAccountRoleOptions = role => {
    switch (role) {
      case ACCOUNT_ROLES.AccountOfficer:
        return [{ label: 'Referent RGPD', value: ACCOUNT_ROLES.AccountOfficer }];
      case ACCOUNT_ROLES.ADMIN:
        return [
          { label: 'Referent RGPD', value: ACCOUNT_ROLES.AccountOfficer },
          { label: 'Administrateur', value: ACCOUNT_ROLES.ADMIN },
        ];
      case ACCOUNT_ROLES.Guest:
        return [
          { label: 'Referent RGPD', value: ACCOUNT_ROLES.AccountOfficer },
          { label: 'Administrateur', value: ACCOUNT_ROLES.ADMIN },
          { label: 'Collaborateur', value: ACCOUNT_ROLES.Guest },
        ];
    }
  };

  return (
    <AdminUserListContainer>
      <ActionsContainer>
        <Button label={'Ajouter un administrateur'} icon={RiAddLine} onClick={handleAddUser} />
        <Button label={'sauvegarder les modifications'} icon={FaRegSave} onClick={handleUpdateAllUsers} type={'success'} />
      </ActionsContainer>

      <UserListContainer>
        <UserListBody admin={admin}>
          <span>N°</span>
          <span>Nom</span>
          <span>Prénom</span>
          <span>Email</span>
          {!admin && <span>Rôle utilisateur</span>}
          {admin && <span>Reçoit les emails</span>}
          {admin && <span>Référent RGPD</span>}
          <span>Actions</span>
          {userList.map((accountUser, index) => {
            return (
              <UserListDataContent key={`accountUser-${index}`}>
                <div>{index + 1}</div>
                <InputComponent
                  type={'text'}
                  name={'name'}
                  disabled={accountUser._id === user._id}
                  key={`accountUserName-${index}`}
                  onChange={e => handleUserInfosChange(e, accountUser)}
                  value={accountUser?.name}
                />
                <InputComponent
                  type={'text'}
                  name={'firstName'}
                  disabled={accountUser._id === user._id}
                  key={`firstName-${index}`}
                  onChange={e => handleUserInfosChange(e, accountUser)}
                  value={accountUser?.firstName}
                />
                <InputComponent
                  type={'text'}
                  name={'email'}
                  disabled={accountUser._id === user._id}
                  key={`accountUserEmail-${index}`}
                  onChange={e => handleUserInfosChange(e, accountUser)}
                  value={accountUser?.email}
                />
                {!admin && (
                  <InputComponent
                    onChange={(e, value) => handleUserInfosChange(e, accountUser, value)}
                    type='select'
                    name={'role'}
                    disabled={accountUser._id === user._id}
                    options={getAccountRoleOptions(accountUser.role)}
                    sharable={false}
                    value={accountRoleOptions.find(option => option.value === accountUser.role)}
                  />
                )}
                {admin && (
                  <div>
                    <label style={{ marginTop: '10px' }} htmlFor={`emailCheckbox-${index}`}>
                      <input
                        disabled={accountUser._id === user._id}
                        defaultChecked={accountUser?.receivesEmails}
                        id={`emailCheckbox-${index}`}
                        name={'receivesEmails'}
                        type='checkbox'
                        onChange={e => handleUserInfosChange(e, accountUser, undefined, true)}
                      />
                    </label>
                  </div>
                )}
                {admin && (
                  <div>
                    <label style={{ marginTop: '10px' }} htmlFor={`accountOfficerCheckbox-${index}`}>
                      <input
                        disabled={accountUser._id === user._id}
                        defaultChecked={accountUser?.role === 'accountOfficer'}
                        id={`accountOfficerCheckbox-${index}`}
                        name={'accountOfficer'}
                        type='radio'
                        onChange={e => handleAccountOfficerChange(e, accountUser)}
                      />
                    </label>
                  </div>
                )}

                <Button label={'Supprimer'} type={'danger'} disabled={accountUser._id === user._id} onClick={() => handlePopUp(accountUser)} />
              </UserListDataContent>
            );
          })}
        </UserListBody>
      </UserListContainer>
      <Modal show={showModal} title={'Attention'} onClose={() => setShowModal(false)}>
        <MessageContainer>
          <div>
            L'utilisateur que vous souhaitez supprimer est le <span>référent RGPD</span> du compte. Veuillez sélectionner un{' '}
            <span>autre responsable RGPD </span>
            avant de supprimer cet utilisateur.
          </div>
        </MessageContainer>
      </Modal>
      <Modal show={displayConfirmModal} title={'Confirmation de changement de status'} onClose={handleCloseConfirmModal}>
        <ConfirmContainer>
          <div>
            Êtes-vous sûr de vouloir supprimer l'utilisateur <span className={`status`}>{selectedUser?.name}</span>?
          </div>
          <ButtonsContainer>
            <Button onClick={() => deleteUser(selectedUser)} label={'Oui'} />
            <Button onClick={handleCloseConfirmModal} label={'Non'} />
          </ButtonsContainer>
        </ConfirmContainer>
      </Modal>
    </AdminUserListContainer>
  );
};
